/* eslint-disable import/no-named-as-default */

import angular from 'angular';
import tierDirective from './tier.directive';
import TierWarning from './warning.component';
import TierService from './tier.service';

import './warning.component.scss';

export default angular.module('autoboard.tenantComponents', [
  tierDirective,
  TierService,
  TierWarning,
])
  .name;
